import { naturalSort, reverseNaturalSort } from '@/helpers/util';

const formatter = 'relativeStackedTimeChart';

/**
 * Format result data that is in a timeseries format with an additional grouping
 */
export default function formatRelativeStackedTimeChart(kpi, result) {
  const displayType = kpi.getDisplayType();
  let displayData = [];

  const { data, meta: { typeY0 } } = result;
  const traceMap = data.reduce((tm, { x, y0, series }) => {
    tm[series] = tm[series] || []; // eslint-disable-line no-param-reassign
    tm[series].push({
      x,
      y: typeY0 === 'percentage' ? y0 / 100 : y0,
    });
    return tm;
  }, {});

  const isPercent = kpi.isPercent();

  // Map traces back to displayData
  const state = kpi.getState();
  Object.keys(traceMap).forEach((k) => {
    const dataItem = {
      key: kpi.getPropertyValueKey(kpi.grouping, k, true),
      type: kpi.getChartDisplayType(),
      values: traceMap[k],
    };

    if (state[k] && state[k].visible === false) {
      dataItem.visible = false;
    }

    if (displayType === 'line') {
      const { displayOptions: { hideLineMarkers } } = kpi;
      dataItem.mode = hideLineMarkers ? 'lines' : 'lines+markers';
    }

    displayData.push(dataItem);
  });

  const sort = kpi.getSort();
  if (sort.order === 'desc') {
    displayData = reverseNaturalSort(displayData, 'key');
  } else {
    displayData = naturalSort(displayData, 'key');
  }
  return {
    displayType,
    displayData,
    isPercent,
    formatter,
  };
}
